<template>
    <v-app>
        <!-- <component :is="appVariant" /> -->
        <span v-if="configResolved">
            <component  :is="appVariant" :configUrl="confURL"></component>
        </span>
    </v-app>
</template>

<script setup>
    import { defineAsyncComponent, ref, onMounted} from 'vue';
    const configResolved = ref(false);
    const confURL = ref('config_cerebra_mui.yaml');
    // Config source order:
    // 1. URL query parameter
    // 2. Header response of base url
    // 3. Manually specified above
    // 4. Local config file
    // If not provided (case 3), the local config URLs will be tried in order at the base URL:
    // 1. config.yaml
    // 2. config.yml
    // 3. config.json
    // Now we set the main component based on VITE_SHACLVUE_VARIANT environment variable
    const variant = import.meta.env.VITE_SHACLVUE_VARIANT
    const componentMap = {
        default: defineAsyncComponent(() => import('@/components/ShaclVue.vue')),
        starter: defineAsyncComponent(() => import('@/components/ShaclVueStarter.vue')),
    }
    const appVariant = componentMap[variant] || componentMap.default;

    onMounted(async () => {
        const mainUrl = new URL(window.location);
        const qparams = mainUrl.searchParams;
        const configParam = qparams.get('config');
        if (configParam) {
            confURL.value = configParam;
            mainUrl.searchParams.delete('config');
            window.history.replaceState(null, '', mainUrl);
        } else {
            let headConfig = await getConfigFromHead(window.location);
            if (headConfig) {
                confURL.value = headConfig;
            }
        }
        configResolved.value = true;
    });

    async function getConfigFromHead(url) {
        try {
            const response = await fetch(url, {method: 'HEAD'});
            for (const [key, value] of response.headers.entries()) {
                if (key.toLowerCase() == 'x-shacl-vue-config') {
                    return value
                }
            }
            return ''
        } catch (error) {
            console.error('HEAD request failed:', error);
            return ''
        }
    }
</script>
